import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'app.shopDetails.components.locationToast.message.title',
    defaultMessage: 'Ingresa tu dirección',
  },
  subtitle: {
    id: 'app.shopDetails.components.locationToast.message.subtitle',
    defaultMessage: 'Queremos verificar que este local entrega a tu ubicación.',
  },
  button: {
    id: 'app.shopDetails.components.locationToast.message.button',
    defaultMessage: 'Ingresar',
  },
});
